/**
 * Dati del venditore mostrati nel footer, nella pagina contatti e nelle
 * pagine legali (obbligatori per l'art. 7 D.Lgs. 70/2003 e l'art. 49 del
 * Codice del Consumo). Ragione sociale e P.IVA arrivano da env come
 * indirizzo e telefono, così si configurano una volta sola su Vercel.
 */

type Address = {
	via?: string;
	comune?: string;
	provincia?: string;
	nazione?: string;
};

function parseAddress(raw: string | undefined): Address | null {
	if (!raw) return null;
	try {
		return JSON.parse(raw) as Address;
	} catch {
		// Formato libero: tutta la stringa come prima riga.
		return { via: raw };
	}
}

function toLines(address: Address | null): string[] {
	if (!address) return [];
	const city =
		address.comune && address.provincia
			? `${address.comune} (${address.provincia})`
			: address.comune || address.provincia;
	return [address.via, city, address.nazione].filter((line): line is string => !!line);
}

const MISSING = "[da completare]";

export const BUSINESS = {
	brand: "Apicoltura DePiccoli",
	legalName: import.meta.env.VITE_LEGAL_NAME || MISSING,
	vatNumber: import.meta.env.VITE_VAT_NUMBER || MISSING,
	email: "apicoltura.depiccoli@gmail.com",
	phone: import.meta.env.VITE_PHONE as string | undefined,
	addressLines: toLines(parseAddress(import.meta.env.VITE_ADDRESS)),
};

export const businessAddressInline = BUSINESS.addressLines.join(", ") || MISSING;
